<template>
  <div>
    <DefaultPage id="financials">
      <div class="hero">
        <div class="hero__call">
          <h1 class="financials-headline-top">Steady &amp; secure</h1>
          <h2 class="financials-headline-btm">for the future</h2>
        </div>
        <img src="../assets/bg-poly.png" class="hero-shape" alt="shape"/>
        <video class="hero__vid" preload="auto" autoplay="true" loop="loop" muted="muted" volume="0">
          <source :src="`${baseUrl}gradient-vid.mp4`" type="video/mp4">
        </video>
        <a :href="`${baseUrl}SVMIC 2020 Annual Report.pdf`"
           download="SVMIC 2020 Annual Report"
           class="download-btn">
          <div class="download-btn__icon">
            <div class="download-btn__icon__inner"></div>
          </div>
          <div class="download-btn__call">
            <p class="top">Download</p>
            <p class="btm">the print pdf</p>
          </div>
        </a>
      </div>
      <ContentSection id="highlights"
                      titleLightOne="Financial"
                      titleHeavyOne="Highlights">
        <div class="grid-container">
          <div class="grid-x">
            <div class="cell" data-aos="fade-up">
              <div class="table-scroll">
                <table class="align-table-1">
                  <thead>
                  <tr>
                    <th><h4>At Year End</h4>
                    <p>($ in thousands)</p></th>
                    <th><h4>2016</h4></th>
                    <th><h4>2017</h4></th>
                    <th><h4>2018</h4></th>
                    <th><h4>2019</h4></th>
                    <th><h4>2020</h4></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td>Cash and Invested Assets</td>
                    <td class="number">1,165,959</td>
                    <td class="number">1,193,190</td>
                    <td class="number">1,208,752</td>
                    <td class="number">1,249,626</td>
                    <td class="number">1,294,540</td>
                  </tr>
                  <tr>
                    <td>Total Assets</td>
                    <td class="number">1,211,111</td>
                    <td class="number">1,249,290</td>
                    <td class="number">1,243,394</td>
                    <td class="number">1,278,382</td>
                    <td class="number">1,321,878</td>
                  </tr>
                  <tr>
                    <td>Loss &amp; Loss Adjustment Expense Reserves</td>
                    <td class="number">491,500</td>
                    <td class="number">472,500</td>
                    <td class="number">469,000</td>
                    <td class="number">455,000</td>
                    <td class="number">456,000</td>
                  </tr>
                  <tr>
                    <td>Policyholders’ Surplus</td>
                    <td class="number">566,994</td>
                    <td class="number">606,774</td>
                    <td class="number">623,955</td>
                    <td class="number">671,735</td>
                    <td class="number">705,694</td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <div class="separate-tables"><!--x--></div>
              <div class="table-scroll">
                <table class="align-table-1">
                  <thead>
                  <tr>
                    <th><h4>For The Year</h4>
                      <p>($ in thousands)</p></th>
                    <th><h4>2016</h4></th>
                    <th><h4>2017</h4></th>
                    <th><h4>2018</h4></th>
                    <th><h4>2019</h4></th>
                    <th><h4>2020</h4></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td>Gross Written Premium</td>
                    <td class="number">130,335</td>
                    <td class="number">125,844</td>
                    <td class="number">120,569</td>
                    <td class="number">119,235</td>
                    <td class="number">113,815</td>
                  </tr>
                  <tr>
                    <td>Net Investment Income</td>
                    <td class="number">29,213</td>
                    <td class="number">27,454</td>
                    <td class="number">32,557</td>
                    <td class="number">29,829</td>
                    <td class="number">28,148</td>
                  </tr>
                  <tr>
                    <td>Net Paid Loss &amp; Loss Adjustment Expenses</td>
                    <td class="number">106,001</td>
                    <td class="number">100,002</td>
                    <td class="number">92,522</td>
                    <td class="number">99,472</td>
                    <td class="number">80,225</td>
                  </tr>
                  <tr>
                    <td>Policyholders’ Dividends Declared</td>
                    <td class="number">7,000</td>
                    <td class="number">7,000</td>
                    <td class="number">7,000</td>
                    <td class="number">7,000</td>
                    <td class="number">7,000</td>
                  </tr>
                  <tr>
                    <td>Net Income</td>
                    <td class="number">22,365</td>
                    <td class="number">29,646</td>
                    <td class="number">28,542</td>
                    <td class="number">22,074</td>
                    <td class="number">23,853</td>
                  </tr>
                  <tr>
                    <td>Cumulative Dividends and Return of Capital</td>
                    <td class="number">349,500</td>
                    <td class="number">356,500</td>
                    <td class="number">363,500</td>
                    <td class="number">370,500</td>
                    <td class="number">377,500</td>
                  </tr>
                  <tr>
                    <td>Outstanding Mutual Value Plan Balances</td>
                    <td class="number">-</td>
                    <td class="number">-</td>
                    <td class="number">68,538</td>
                    <td class="number">82,272</td>
                    <td class="number">87,463</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </ContentSection>
      <ContentSection id="balance-sheets"
                      titleLightOne="Condensed"
                      titleHeavyOne="Balance"
                      titleLightTwo="Sheets"
                      subtext="(as of December 31, 2020 &amp; 2019)"
                      geometry>
        <div class="grid-container">
          <div class="grid-x">
            <div class="cell" data-aos="fade-up">
              <div class="table-scroll">
                <table class="align-table-2 right-aligned">
                  <thead>
                  <tr>
                    <th><h4>Assets</h4></th>
                    <th><h4>2020</h4></th>
                    <th><h4>2019</h4></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td>Cash &amp; Investments</td>
                    <td class="number">1,294,540,000</td>
                    <td class="number">1,249,626,000</td>
                  </tr>
                  <tr>
                    <td>Premiums Receivable</td>
                    <td class="number">13,545,000</td>
                    <td class="number">15,690,000</td>
                  </tr>
                  <tr>
                    <td>Accrued Investment Income</td>
                    <td class="number">8,540,000</td>
                    <td class="number">8,428,000</td>
                  </tr>
                  <tr>
                    <td>Reinsurance Recoverable</td>
                    <td class="number">4,484,000</td>
                    <td class="number">4,099,000</td>
                  </tr>
                  <tr>
                    <td>Federal Income Taxes Recoverable</td>
                    <td class="number">439,000</td>
                    <td class="number">409,000</td>
                  </tr>
                  <tr>
                    <td class="bb">Other Assets</td>
                    <td class="bb number">330,000</td>
                    <td class="bb number">130,000</td>
                  </tr>
                  </tbody>
                  <tfoot>
                  <tr>
                    <th>Total Assets</th>
                    <th class="number">$1,321,878,000</th>
                    <th class="number">$1,278,382,000</th>
                  </tr>
                  </tfoot>
                </table>
              </div>
              <div class="separate-tables"><!--x--></div>
              <div class="table-scroll">
                <table class="align-table-2 right-aligned">
                  <thead>
                  <tr>
                    <th>
                      <h4>Liabilities &amp; Policyholders’ Surplus</h4>
                      <p>Liabilities</p>
                    </th>
                    <th><h4>2020</h4></th>
                    <th><h4>2019</h4></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td>Loss &amp; Loss Adjustment Expense Reserves</td>
                    <td class="number">456,000,000</td>
                    <td class="number">455,000,000</td>
                  </tr>
                  <tr>
                    <td>Unearned Premiums</td>
                    <td class="number">63,084,000</td>
                    <td class="number">63,825,000</td>
                  </tr>
                  <tr>
                    <td>Reinsurance Balances Payable</td>
                    <td class="number">21,686,000</td>
                    <td class="number">18,783,000</td>
                  </tr>
                  <tr>
                    <td>Accounts Payable and Accrued Expenses</td>
                    <td class="number">63,529,000</td>
                    <td class="number">61,664,000</td>
                  </tr>
                  <tr>
                    <td>Net Deferred Tax Liabilities</td>
                    <td class="number">3,786,000</td>
                    <td class="number">452,000</td>
                  </tr>
                  <tr>
                    <td>Dividends Payable</td>
                    <td class="number">2,696,000</td>
                    <td class="number">2,707,000</td>
                  </tr>
                  <tr>
                    <td class="bb">Other Liabilities</td>
                    <td class="bb number">5,403,000</td>
                    <td class="bb number">4,216,000</td>
                  </tr>
                  <tr>
                    <th>Total Liabilities</th>
                    <th class="number">$616,184,000</th>
                    <th class="number">$606,647,000</th>
                  </tr>
                  </tbody>
                </table>
                <br>
                <table class="align-table-2 right-aligned">
                  <tbody>
                  <tr>
                    <th><p class="sub-title-financial">Policyholders’ Surplus</p></th>
                  </tr>
                  <tr>
                    <td>Expected Mutual Value Plan Obligation</td>
                    <td class="number">29,121,000</td>
                    <td class="number">26,033,000</td>
                  </tr>
                  <tr>
                    <td class="bb">Unassigned Surplus</td>
                    <td class="bb number">676,573,000</td>
                    <td class="bb number">645,702,000</td>
                  </tr>
                  <tr>
                    <th style="font-weight: 600;" class="bb">Total Policyholders’ Surplus</th>
                    <th style="font-weight: 600;" class="bb number">$705,694,000</th>
                    <th style="font-weight: 600;" class="bb number">$671,735,000</th>
                  </tr>
                  </tbody>
                  <tfoot>
                  <tr>
                    <th>Total Liabilities &amp; Policyholders’ Surplus</th>
                    <th class="number">$1,321,878,000</th>
                    <th class="number">$1,278,382,000</th>
                  </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          </div>
        </div>
      </ContentSection>
      <ContentSection id="statements-of-income"
                      titleLightOne="Condensed"
                      titleHeavyOne="Statements"
                      titleLightTwo="of"
                      titleHeavyTwo="Income"
                      subtext="(For the years ended December 31, 2020 &amp; 2019)"
                      geometry>
        <div class="grid-container">
          <div class="grid-x">
            <div class="cell" data-aos="fade-up">
              <div class="table-scroll">
                <table class="align-table-2 right-aligned">
                  <thead>
                  <tr>
                    <th><h4>&nbsp;</h4></th>
                    <th><h4>2020</h4></th>
                    <th><h4>2019</h4></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td>Gross Written Premium</td>
                    <td class="number">113,815,000</td>
                    <td class="number">119,235,000</td>
                  </tr>
                  <tr>
                    <td>Ceded Premium</td>
                    <td class="number">(11,537,000)</td>
                    <td class="number">(8,895,000)</td>
                  </tr>
                  <tr style="border-top: 1px solid black !important;">
                    <td>Net Written Premium</td>
                    <th class="number">$102,278,000</th>
                    <th class="number">$110,340,000</th>
                  </tr>
                  <tr>
                    <td>Change in Unearned Premium</td>
                    <td class="number">742,000</td>
                    <td class="number">633,000</td>
                  </tr>
                  <tr style="border-top: 1px solid black !important;">
                    <td>Net Earned Premium</td>
                    <th class="number no-extra-padding">$103,020,000</th>
                    <th class="number no-extra-padding">$110,973,000</th>
                  </tr>
                  </tbody>
                </table>
                <br>
                <table class="align-table-2 right-aligned">
                  <tbody>
                  <tr>
                    <td>Loss &amp; Loss Adjustment Expenses Incurred</td>
                    <td class="number">81,225,000</td>
                    <td class="number">85,472,000</td>
                  </tr>
                  <tr>
                    <td>Other Underwriting Expenses</td>
                    <td class="number">23,816,000</td>
                    <td class="number">23,990,000</td>
                  </tr>
                  </tbody>
                  <tbody class="bl-border">
                  <tr>
                    <td>Net Underwriting Income</td>
                    <th class="number">($2,021,000)</th>
                    <th class="number">$1,511,000</th>
                  </tr>
                  </tbody>
                </table>
                <br>
                <table class="align-table-2 right-aligned">
                  <tbody>
                  <tr>
                    <td>Net Investment Income</td>
                    <td class="number">28,148,000</td>
                    <td class="number">29,829,000</td>
                  </tr>
                  <tr>
                    <td>Net Realized Capital Gains (Losses) on Investments</td>
                    <td class="number">7,912,000</td>
                    <td class="number">1,207,000</td>
                  </tr>
                  </tbody>
                  <tbody class="bl-border">
                    <tr>
                      <td>Net Investment Gains</td>
                      <th class="number">$36,060,000</th>
                      <th class="number">$31,036,000</th>
                    </tr>
                  </tbody>
                </table>
                <br>
                <table class="align-table-2 right-aligned">
                  <tbody>
                    <tr style="border-bottom: 1px solid black !important; background-color: white !important;">
                      <td style="padding-top: 15px;">Other Income (Expense)</td>
                      <td style="padding-top: 15px;" class="number">(204,000)</td>
                      <td style="padding-top: 15px;" class="number">(63,000)</td>
                    </tr>
                  </tbody>
                </table>
                <br>
                <table class="align-table-2 right-aligned">
                  <tbody>
                  <tr>
                    <td>Net Income Before Taxes and Policyholders’ Dividends</td>
                    <td class="number bold">$33,835,000</td>
                    <td class="number bold">$32,484,000</td>
                  </tr>
                  <tr>
                    <td class="bb">Policyholders’ Dividends &amp; Federal Income Taxes Incurred</td>
                    <td class="bb number">(9,982,000)</td>
                    <td class="bb number">(10,410,000)</td>
                  </tr>
                  </tbody>
                  <tfoot>
                  <tr>
                    <td>Net Income</td>
                    <td class="number">$23,853,000</td>
                    <td class="number">$22,074,000</td>
                  </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          </div>
          <div class="grid-x">
            <div class="cell large-7 medium-9">
              <p class="note">Note: The financial statements have been prepared in conformity with accounting practices
                prescribed or permitted by the Tennessee Department of Commerce and Insurance. The condensed financial
                information has been derived from the complete statutory-basis financial statements which were audited
                by Ernst &amp; Young LLP, our independent auditors. A complete set of audited financial statements is
                available upon request.</p>
            </div>
          </div>
        </div>
      </ContentSection>
      <ContentSection id="policyholders-surplus"
                      titleLightOne="Policyholders'"
                      titleHeavyOne="Surplus /"
                      titleLightTwo="Total"
                      titleHeavyTwo="Assets"
                      geometry>
        <div class="grid-container">
          <div class="chart-label-container"
               data-aos="fade-down">
            <div class="grid-x">
              <div class="large-3 small-6">
                <div class="chart-label">
                  <div class="dot label1">
                  </div>
                  <p>Policyholders’ Surplus</p>
                </div>
              </div>
              <div class="large-3 small-6">
                <div class="chart-label">
                  <div class="dot label2">
                  </div>
                  <p>Total Assets</p>
                </div>
              </div>
            </div>
          </div>
          <ChartContainer chartClass="chart-container-policyholders-surplus">
            <PolicyholdersSurplusChart/>
          </ChartContainer>
        </div>
      </ContentSection>
      <ContentSection id="cumulative-dividends"
                      titleLightOne="Cumulative"
                      titleHeavyOne="Dividends"
                      titleLightTwo="Declared"
                      titleHeavyTwo="&amp;"
                      titleLightThree="Return of"
                      titleHeavyThree="Capital"
                      geometry>
        <div class="grid-container">
          <ChartContainer chartClass="chart-container-cumulative-dividends">
            <CumulativeDividendsChart/>
          </ChartContainer>
        </div>
      </ContentSection>
      <ContentSection id="premiums-per-physician"
                      titleLightOne="Premiums"
                      titleHeavyOne="Per"
                      titleLightTwo="Physician"
                      geometry>
        <div class="grid-container">
          <div class="chart-label-container"
               data-aos="fade-down">
            <div class="grid-x">
              <div class="large-4 small-6">
                <div class="chart-label">
                  <div class="dot label3">
                  </div>
                  <p>Average Premium Per Physician</p>
                </div>
              </div>
              <div class="large-4 small-6">
                <div class="chart-label">
                  <div class="dot label4">
                  </div>
                  <p>Average Premium Per Physician</p>
                  <p class="sub-label">(in today's dollars)</p>
                </div>
              </div>
            </div>
          </div>
          <ChartContainer chartClass="chart-container-premiums-per-physician">
            <PremiumsPerPhysicianChart/>
          </ChartContainer>
        </div>
      </ContentSection>
    </DefaultPage>
  </div>
</template>

<script>
import DefaultPage from '@/layouts/DefaultPage';
import ContentSection from '@/components/section/VisualDataSection';
import PolicyholdersSurplusChart from '@/components/chart/PolicyholdersSurplusChart';
import ChartContainer from '@/components/chart/ChartContainer';
import CumulativeDividendsChart from '@/components/chart/CumulativeDividendsChart';
import PremiumsPerPhysicianChart from '@/components/chart/PremiumsPerPhysicianChart';

export default {
  name: 'Financials',
  components: {
    PremiumsPerPhysicianChart,
    CumulativeDividendsChart,
    ChartContainer,
    PolicyholdersSurplusChart,
    ContentSection,
    DefaultPage
  },
  data () {
    return {
      baseUrl: process.env.BASE_URL
    };
  }
};
</script>
